import { StyledGrid, TitleContainer } from "../Styled";
import { OptionTitle } from "components/Styled";
import { useTranslation } from "react-i18next";
import { FormState } from "../types";
import { Box, Grid, TextField } from "@material-ui/core";
import React from "react";
import useVariables from "utils/useVariables";

export default function ReadOnlyMappings({
  mappings,
}: {
  mappings: FormState["mappings"];
}) {
  const { t } = useTranslation("templateDefinitions");
  const { translateVar, variableOptions } = useVariables();

  return (
    <>
      <TitleContainer>
        <OptionTitle variant="subtitle1" color="textPrimary">
          {t("form.mappings.title")}
        </OptionTitle>
      </TitleContainer>
      <StyledGrid container spacing={1} direction="row" alignItems="center">
        {mappings.map(({ id, value, key }) => {
          const { name } = translateVar(value as string, variableOptions);
          return (
            <React.Fragment key={id}>
              <Grid item xs={6}>
                <TextField
                  label={t("form.mappings.key.label")}
                  variant="outlined"
                  value={key}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <TextField
                    label="Value"
                    variant="outlined"
                    disabled
                    value={name}
                    fullWidth
                  />
                </Box>
              </Grid>
            </React.Fragment>
          );
        })}
      </StyledGrid>
    </>
  );
}
